import { render, staticRenderFns } from "./IconArrowDownTriangle.vue?vue&type=template&id=035f39b8"
import script from "./IconArrowDownTriangle.vue?vue&type=script&lang=ts"
export * from "./IconArrowDownTriangle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports